import { render, staticRenderFns } from "./field-textarea.vue?vue&type=template&id=7f3d8352&scoped=true"
import script from "./field-textarea.vue?vue&type=script&lang=js"
export * from "./field-textarea.vue?vue&type=script&lang=js"
import style0 from "./field-textarea.vue?vue&type=style&index=0&id=7f3d8352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d8352",
  null
  
)

export default component.exports